import { Component, Input } from '@angular/core';
import { divider, DividerProps } from '@kite_aerolab/shared/components';

@Component({
  selector: 'kite-divider',
  template: '<hr [ngClass]="divider" role="separator" />',
})
export class DividerComponent implements DividerProps {
  /**
   * Color de la línea
   */
  @Input() color: DividerProps['color'];
  /**
   * Orientation del divider
   */
  @Input() orientation: DividerProps['orientation'];

  @Input() css: DividerProps['css'];

  public get divider(): string[] {
    return [
      divider({
        orientation: this.orientation,
        color: this.color,
        css: this.css,
      }).className,
    ];
  }
}
